import { gql } from '@apollo/client';

export const GET_AB_TESTS = gql`
  query getClientABTests {
    abTests @client {
      experiments {
        name
        variantName
        variantId
        __typename
      }
    }
  }
`;
